export default "__VITE_ASSET__C0de2LHU__"